module.exports = __webpack_public_path__ + "assets/images/b46c7b70ca343b642df71e3936720617.png";